const url = "https://js.stripe.com/v3/";

export const load = (...args) => {
  return new Promise((resolve, reject) => {
    if (isIntegrated()) {
      resolve(init(...args));
      return;
    }

    try {
      const script = document.createElement("script");
      document.head.appendChild(script);

      script.onload = () => resolve(init(...args));
      script.onerror = err => reject(err);

      script.setAttribute("src", url);
    } catch (err) {
      reject(err);
    }
  });
};

const init = (nodeId, onChange) => {
  const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PK);
  const elements = stripe.elements();

  const card = elements.create("card", {
    hidePostalCode: true,
    style: {
      base: {
        color: "initial",
        fontFamily: "CircularStd-Book, sans-serif"
      },
      invalid: {
        color: "#ff4136"
      }
    }
  });

  card.mount("#" + nodeId);

  card.addEventListener("change", event => {
    if (event.error) {
      onChange(event.error.message);
    } else {
      onChange(void 0);
    }
  });

  return (onSuccess, onFailure) =>
    stripe
      .createToken(card)
      .then(result => {
        if (result.error) {
          onFailure(result.error.message);
        } else {
          onSuccess(result.token);
        }
      })
      .catch(err => {
        onFailure(err.message);
      });
};

const isIntegrated = () =>
  Array.from(document.getElementsByTagName("script")).filter(
    script => script.src === url
  ).length > 0;



// WEBPACK FOOTER //
// ./src/core/integrations/stripe/index.js